import React ,{useState, useEffect} from "react";
import { Button , Form, Input, Modal , Select , Tooltip , Row , Col, Checkbox, Calendar } from "antd";
import { checkActionAllowed , isValid, isValidArray} from "../../utils/utilities";
import { ACTION_TO_EDIT_VECHICLE_INFO_FROM_AGENT_PORTAL, ACTION_TO_VIEW_VEHICLE_INFO } from './../../utils/constant';
import Icon, { SwapOutlined, CalendarOutlined, LeftOutlined, RightOutlined } from '@ant-design/icons';
import LocationGrayIcon from './../../images/location-gray.png';
import { getAPIDateFormat, getFormatedDate, firstDayOfMonth, lastDayOfMonth } from './../../utils/date.utils';
import './edit-vechicle.style.scss';
import { updatePhoneNoandVechicleNo} from './edit-vechicle.module';
import { loadingAction } from './../../actions/loading-actions';
import { useDispatch } from "react-redux";
import { StaffSelect } from "../search-components/staff-select-component/staff-select.component";
import { getStaffDetails } from "../search-components/staff-select-component/staff-select.module";
import { getSchedulesByIdForDates } from "../../actions/admin.action";
import moment from 'moment';

const { 
    Option
} = Select;

const getVechicleNo=(vechicleId,vechicles)=>{
    let vechicleNo=null;
    
    for (let index = 0; index < vechicles.length; index++) {
        const element = vechicles[index];
        if(element.id == vechicleId){
            vechicleNo = element.vechicle_no.replace(/\s+/g, '');
        }
    }
    return vechicleNo;
}

const renderVechicles=(vechicles,busId)=>
{
    let vechicleOptions=[<Option value={0}>None</Option>] ;
    if(isValidArray(vechicles)&&vechicles.length>0){
        vechicles.forEach(element => {
            if(busId === element.bus_id){
                vechicleOptions.push(<Option value={element.id}>{element.vechicle_no}</Option>);
            }
        });
    }
    return vechicleOptions;
}

const EditDrawLine =()=>{

    return(
        <div className="edit-vechicle-underline">

        </div>
    )
}

export const EditVechicleComponent = (props) => {

    const{
        scheduleDescription,
        travelDate,
        selectedTrip,
        phoneNo,
        vechicleId,
        vechicleInfoExits,
        busId,
        onVechicleUpdateSuccess,
        secondDriverName,
        driverName,
        secondPhoneNo,
        vechicles=[],
        tripInstruction=''
    }=props;

    const [isModalVisible, setIsModalVisible] = useState(false);
    const [staff,setStaff] = useState([]);
    const [assignForOtherDays, setAssignForOtherDays] = useState(false);
    const [calendarMonth, setCalendarMonth] = useState(moment(travelDate));
    const [selectedDates, setSelectedDates] = useState([]);
    const [activeDatesMap, setActiveDatesMap] = useState({});
    const dispatch = useDispatch();
    const [form] = Form.useForm();

    useEffect(() => {
        if (!isModalVisible || !assignForOtherDays || !selectedTrip || !selectedTrip.schedule_id) {
            return;
        }
        let startDate = firstDayOfMonth(calendarMonth);
        let endDate = lastDayOfMonth(calendarMonth);
        getSchedulesByIdForDates(
            selectedTrip.schedule_id,
            startDate,
            endDate,
            (data) => {
                let map = {};
                if (isValidArray(data)) {
                    data.forEach((trip) => {
                        let apidate = getAPIDateFormat(trip.start_date);
                        map[apidate] = trip;
                    });
                }
                setActiveDatesMap(map);
            },
            () => {
                setActiveDatesMap({});
            }
        );
    }, [isModalVisible, assignForOtherDays, calendarMonth, selectedTrip && selectedTrip.schedule_id]);

    const isDateActive = (apidate) => {
        let info = activeDatesMap[apidate];
        return isValid(info) && info.is_active == 1;
    };


    const showModal = () => {
        getStaffDetails((info)=>{
            setStaff(info);
            setIsModalVisible(true);
        },()=>{})
    };

    const resetOtherDaysState = () => {
        setAssignForOtherDays(false);
        setSelectedDates([]);
        setCalendarMonth(moment(travelDate));
    };

    const handleOk = () => {
        setIsModalVisible(false);
        resetOtherDaysState();
    };

    const handleCancel = () => {
        setIsModalVisible(false);
        resetOtherDaysState();
    };

    const getFutureDatesOfMonth = (monthMoment, alternate) => {
        let dates = [];
        let today = moment().startOf('day');
        let travelMoment = moment(travelDate).startOf('day');
        let monthStart = moment(monthMoment).startOf('month');
        let monthEnd = moment(monthMoment).endOf('month');

        // Anchor on the travel date when the displayed month contains it; otherwise the month start.
        let anchor;
        if (travelMoment.isSame(monthMoment, 'month') && travelMoment.isSame(monthMoment, 'year')) {
            anchor = travelMoment.clone();
        } else {
            anchor = monthStart.clone();
        }
        if (anchor.isBefore(today)) {
            anchor = today.clone();
        }
        if (anchor.isAfter(monthEnd)) {
            return dates;
        }

        let cursor = anchor.clone();
        let step = alternate ? 2 : 1;
        while (cursor.isSameOrBefore(monthEnd, 'day')) {
            let apidate = cursor.format('YYYY-MM-DD');
            if (isDateActive(apidate)) {
                dates.push(apidate);
            }
            cursor.add(step, 'days');
        }
        return dates;
    };

    const handlePatternSelect = (alternate) => {
        let dates = getFutureDatesOfMonth(calendarMonth, alternate);
        setSelectedDates(dates);
    };

    const handleDateClick = (date) => {
        let apidate = getAPIDateFormat(date);
        if (date.month() !== calendarMonth.month() || date.year() !== calendarMonth.year()) {
            return;
        }
        if (moment(apidate).isBefore(moment().startOf('day'))) {
            return;
        }
        if (!isDateActive(apidate)) {
            return;
        }
        setSelectedDates((prev) => {
            let index = prev.indexOf(apidate);
            if (index === -1) {
                return [...prev, apidate];
            }
            let copy = [...prev];
            copy.splice(index, 1);
            return copy;
        });
    };

    const onCalendarPanelChange = (value) => {
        setCalendarMonth(value);
    };

    const goPrevMonth = () => {
        setCalendarMonth(moment(calendarMonth).subtract(1, 'month'));
    };

    const goNextMonth = () => {
        setCalendarMonth(moment(calendarMonth).add(1, 'month'));
    };

    const setLoading = (value)=>{
        dispatch(loadingAction(value));
    }
    
    const getVehicleNoFromId = (vehicleId) => {
        let vehicleNo = null;
        vechicles.map((vehicle) => {
            if (vehicleId == vehicle.id) {
                vehicleNo = vehicle.vechicle_no;
            }
        });
        return vehicleNo;
    }
    
    const handleSubmit =  (e) => {
        e.preventDefault();
        return form.validateFields()
        .then(values => {
            let vehicleId = values.vechicleId==0?null:values.vechicleId;
            let vehicleNo = getVehicleNoFromId(vehicleId)
            let trip = {
                id:selectedTrip.id,
                schedule_id:selectedTrip.schedule_id,
                vechicle_id:vehicleId,
                vehicleNo,
                phone_no:values.phoneNo,
                driver_name:values.driverName,
                second_driver_name:values.secondDriverName,
                second_driver_phone_no:values.secondPhoneNo,
                conductor_name: values.conductorName,
                conductor_phone: values.conductorPhone,
                operator_code:global.operatorCode,
                doj:getAPIDateFormat(selectedTrip.start_date),
                trip_instruction:values.tripInstruction
            };

            if (assignForOtherDays && selectedDates.length > 0) {
                let tripDate = getAPIDateFormat(selectedTrip.start_date);
                let allDates = selectedDates.includes(tripDate) ? [...selectedDates] : [...selectedDates, tripDate];
                trip.travel_dates = allDates;
            }

            setLoading(true);
            updatePhoneNoandVechicleNo(trip,()=>{
                setLoading(false);
                handleCancel();
                onVechicleUpdateSuccess(vehicleId,values.phoneNo);
            },()=>{
                setLoading(false);
            })
          return true;
        }).catch((err)=>{
          return false;
        })
    }

    let isValidVechicleId = getVechicleNo(vechicleId,vechicles);
    
    if(checkActionAllowed(ACTION_TO_EDIT_VECHICLE_INFO_FROM_AGENT_PORTAL) || checkActionAllowed(ACTION_TO_VIEW_VEHICLE_INFO)){
        let className = isModalVisible?"displayNone":'';
        let title = 'Assign Vehicle number & Driver Phone';
        
        // Build title with available driver information
        const driverDetails = [];
        if(isValid(driverName)) {
            driverDetails.push(`Driver-1: ${driverName}${phoneNo ? ` (${phoneNo})` : ''}`);
        }
        if(isValid(secondDriverName)) {
            driverDetails.push(`Driver-2: ${secondDriverName}${secondPhoneNo ? ` (${secondPhoneNo})` : ''}`);
        }
        title = driverDetails.length > 0 ? driverDetails.join(' | ') : title;

        return (
            <div>
                <Tooltip placement="topLeft" title={title} overlayClassName={className}>

                    <Button 
                    onClick={showModal}
                    disabled= {checkActionAllowed(ACTION_TO_VIEW_VEHICLE_INFO)&&!checkActionAllowed(ACTION_TO_EDIT_VECHICLE_INFO_FROM_AGENT_PORTAL)}
                    ghost 
                    className="open-select-seat-btn">
                        {vechicleInfoExits&&isValidVechicleId?
                        isValidVechicleId
                        :
                        <Icon component={() => (<img src={LocationGrayIcon} style={{width:'23px',padding:'1px'}} />)} />
                        }
                    </Button>
                </Tooltip>
                <Modal 
                centered={true}
                visible={isModalVisible} 
                onOk={handleOk} 
                onCancel={handleCancel}
                className="edit-fare-modal"
                okText="Update"
                footer={null}
                >
                    <div>
                        <div className='fontWeightBold'>
                            Assign Vehicle & Driver
                        </div>
                        <EditDrawLine />
                        <div className="fontWeightBold">
                            {scheduleDescription}
                        </div>
                        <div>
                            Travel Date : {getFormatedDate(travelDate,true,true,true,'.')}
                        </div>
                        <div>
                            <Form
                             form={form}
                             name="basic"
                             initialValues={{
                                 vechicleId:isValidVechicleId?vechicleId:null,
                                 phoneNo,
                                 secondDriverName,
                                 driverName,
                                 secondPhoneNo,
                                 tripInstruction
                             }}
                             labelCol={{ span: 8 }}
                                wrapperCol={{ span: 16 }}
                            >
                                <Form.Item
                                    label="Vechicle #"
                                    name="vechicleId"
                                    rules={[{ required: true, message: 'Please select vechicle' }]}
                                >
                                        <Select
                                                size="large"
                                                showSearch
                                                placeholder="Select a vechicle"
                                                optionFilterProp="children"
                                                filterOption={(input, option) =>
                                                        option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                                    }
                                                bordered={true}
                                                >
                                                {renderVechicles(vechicles,busId)}
                                        </Select>
                                </Form.Item>
                                
                                <Form.Item
                                    label="Trip Instructions"
                                    name="tripInstruction"
                                    rules={[{ required: false }]}
                                >
                                    <Input.TextArea rows={4} />
                                </Form.Item>

                                <Row gutter={[16,16]}>
                                    <Col>
                                        <StaffSelect 
                                            data={staff}
                                            formName={"driverName"}
                                            isFormItem={true}
                                            isManditory={false}
                                            showLabel={true}
                                            showLabelName="Driver name-1"
                                            onChange={(value,info)=>{
                                                if(isValid(info)&&isValid(info.staff)&&isValid(info.staff.phone_number)){
                                                    form.setFieldsValue({phoneNo:info.staff.phone_number});
                                                }
                                            }}
                                            staffType={"Driver"}
                                        /> 
                                    </Col>
                                    <Col>
                                        <Form.Item
                                            label="Phone #"
                                            name="phoneNo"
                                            rules={[{ required: true, message: 'Please enter phone number' }]}
                                        >
                                                <Input />
                                        </Form.Item> 
                                    </Col>
                                </Row>
                                <Row gutter={[16,16]}>
                                    <Col>
                                        <StaffSelect 
                                            data={staff}
                                            formName={"secondDriverName"}
                                            isFormItem={true}
                                            isManditory={false}
                                            showLabel={true}
                                            showLabelName="Driver name-2"
                                            onChange={(value,info)=>{
                                                if(isValid(info.staff)&&isValid(info.staff.phone_number)){
                                                    form.setFieldsValue({secondPhoneNo:info.staff.phone_number});
                                                }
                                            }}
                                            staffType={"Driver"}
                                        /> 
                                    </Col>
                                    <Col>
                                        <Form.Item
                                            label="Phone #"
                                            name="secondPhoneNo"
                                            rules={[{ required: false, message: 'Please enter phone number' }]}
                                        >
                                                <Input />
                                        </Form.Item>  
                                    </Col>
                                </Row>

                                <Row gutter={[16,16]}>
                                    <Col>
                                        <StaffSelect
                                            data={staff}
                                            formName={"conductorName"}
                                            isFormItem={true}
                                            isManditory={false}
                                            showLabel={true}
                                            showLabelName={<span style={{ fontSize: '11px' }}>Conductor Name</span>}
                                            onChange={(value,info)=>{
                                                if(isValid(info.staff)&&isValid(info.staff.phone_number)){
                                                    form.setFieldsValue({conductorPhone:info.staff.phone_number});
                                                }
                                            }}
                                            staffType={"Conductor"}
                                        />
                                    </Col>
                                    <Col>
                                        <Form.Item
                                            label="Phone #"
                                            name="conductorPhone"
                                            rules={[{ required: false, message: 'Please enter conductor phone number' }]}
                                        >
                                            <Input placeholder="Conductor Phone" />
                                        </Form.Item>
                                    </Col>
                                </Row>
                            </Form>
                            <div className="assign-other-days-block">
                                <Checkbox
                                    checked={assignForOtherDays}
                                    onChange={(e) => {
                                        setAssignForOtherDays(e.target.checked);
                                        if (!e.target.checked) {
                                            setSelectedDates([]);
                                        }
                                    }}
                                >
                                    <span style={{ fontWeight: 600 }}>Assign for other days</span>
                                    <span style={{ color: '#888', marginLeft: 8 }}>
                                        — apply this vehicle &amp; crew to additional dates
                                    </span>
                                </Checkbox>
                                {assignForOtherDays && (
                                    <div className="assign-other-days-calendar">
                                        <Row gutter={[8,8]} style={{ marginTop: 8, marginBottom: 8 }}>
                                            <Col>
                                                <Button
                                                    className="pattern-btn"
                                                    icon={<SwapOutlined />}
                                                    onClick={() => handlePatternSelect(true)}
                                                >
                                                    Alternate days
                                                </Button>
                                            </Col>
                                            <Col>
                                                <Button
                                                    className="pattern-btn"
                                                    icon={<CalendarOutlined />}
                                                    onClick={() => handlePatternSelect(false)}
                                                >
                                                    Every day
                                                </Button>
                                            </Col>
                                        </Row>
                                        <Calendar
                                            fullscreen={false}
                                            value={calendarMonth}
                                            onPanelChange={onCalendarPanelChange}
                                            onSelect={handleDateClick}
                                            headerRender={() => (
                                                <Row justify="space-between" align="middle" className="custom-cal-header">
                                                    <Col>
                                                        <span className="cal-nav-arrow" onClick={goPrevMonth}>
                                                            <LeftOutlined />
                                                        </span>
                                                    </Col>
                                                    <Col>
                                                        <span className="custom-cal-title">{calendarMonth.format('MMMM YYYY')}</span>
                                                    </Col>
                                                    <Col>
                                                        <span className="cal-nav-arrow" onClick={goNextMonth}>
                                                            <RightOutlined />
                                                        </span>
                                                    </Col>
                                                </Row>
                                            )}
                                            dateFullCellRender={(date) => {
                                                let apidate = getAPIDateFormat(date);
                                                let isSelected = selectedDates.indexOf(apidate) !== -1;
                                                let isPast = moment(apidate).isBefore(moment().startOf('day'));
                                                let isCurrentMonth = date.month() === calendarMonth.month();
                                                let isInactive = isCurrentMonth && !isPast && !isDateActive(apidate);
                                                return (
                                                    <div
                                                        className={`assign-other-days-cell${isSelected ? ' driver-assign-cal-selected' : ''}${isPast ? ' past' : ''}${isCurrentMonth ? '' : ' off-month'}${isInactive ? ' inactive' : ''}`}
                                                        title={isInactive ? 'No trip on this date' : ''}
                                                    >
                                                        {date.date()}
                                                    </div>
                                                );
                                            }}
                                        />
                                        <Row justify="space-between" align="middle" style={{ marginTop: 8, fontSize: 12, color: '#888' }}>
                                            <Col>Travel date</Col>
                                            <Col>{selectedDates.length} day{selectedDates.length === 1 ? '' : 's'} total</Col>
                                        </Row>
                                    </div>
                                )}
                            </div>
                        </div>
                        <div className="footer-block">
                            <div className="cancel-button-root" onClick={handleCancel}>
                                <Button className="exit-btn">Cancel</Button>
                            </div>
                            <div>
                                <Button onClick={handleSubmit}>Update</Button>
                            </div>
                        </div>
                    </div>
                </Modal>
            </div>
        )
    }else{
        return null
    }
}